import {
  QUOTE_EXPIRATION_OPTIONS,
  SUCCESSIVE_LEASE_TERM_OPTIONS,
  HOUSING_ASSISTANCE_VOUCHER_OPTIONS,
} from './constants';

export const formatQuoteExpirationTime = (quoteExpTime) => {
  const quoteExpirationOpt = QUOTE_EXPIRATION_OPTIONS.find(
    (qeo) => qeo.value === quoteExpTime,
  );
  return quoteExpirationOpt?.label ?? '---';
};

export const getQuoteExpirationOptions = () =>
  QUOTE_EXPIRATION_OPTIONS.map((opt) => (
    <option
      key={`quote-exp-options-${opt.value}`}
      value={opt.value}
      name="quoteExpTime"
    >
      {opt.label}
    </option>
  ));

export const getSuccessiveLeaseTermOptions = (intl: Object, messages: Object) =>
  SUCCESSIVE_LEASE_TERM_OPTIONS.map((opt) => (
    <option
      key={`successive-lease-term-options-${opt.value}`}
      value={opt.value}
    >
      {intl.formatMessage(messages[opt.label])}
    </option>
  ));

export function getUsesFortressPayments(paymentProviders = []) {
  return (
    paymentProviders.find((pp) => pp.paymentProvider === 'FORTRESS') !==
    undefined
  );
}

export const getHousingAssistanceVoucherOptions = () =>
  HOUSING_ASSISTANCE_VOUCHER_OPTIONS.map((opt) => (
    <option
      key={`housing-assistance-voucher-options-${opt.value}`}
      value={opt.value}
      name="housingAssistanceVoucher"
    >
      {opt.label}
    </option>
  ));

export const formatHousingAssistanceVoucher = (
  housingAssistanceVoucher: boolean,
) => {
  const housingAssistanceVoucherOpt = HOUSING_ASSISTANCE_VOUCHER_OPTIONS.find(
    (option) =>
      housingAssistanceVoucher
        ? option.label.includes('Yes')
        : option.label.includes('No'),
  );
  return housingAssistanceVoucherOpt?.label ?? '---';
};

/**
 * Checks whether an interest rate value has been entered (as opposed to being empty).
 * This is needed because 0 is a valid interest rate, but JavaScript
 * treats 0 as falsy — so standard truthy checks like `!rate.interest` would
 * incorrectly reject it. This distinguishes "user entered 0" from "no value entered".
 */
export const isValidInterestRate = (
  interest: number | null | undefined,
): boolean => interest !== null && interest !== undefined && interest !== '';
